import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { queryClient } from "./lib/queryClient";
import "./index.css";

// StrictMode is intentionally NOT used here — wavesurfer.js v7's MediaElement +
// SpectrogramPlugin chain doesn't survive StrictMode's mount → unmount → mount
// double-invocation in dev (AudioContext is torn down mid-fetch, and the second
// instance never recovers). Production builds don't double-invoke regardless.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);
